/* eslint-disable react-hooks/rules-of-hooks */
import { Card, Flexbox, LoadManager } from '@/components'
import { singularStatusMapLabel, statusColorMap } from '@/constants/osm'
import useAxiosRequest from '@/hooks/useAxiosRequest'
import dateMask from '@/lib/masks/date'
import mistreatments from '@/services/api/mistreatments'
import PropTypes from 'prop-types'
import React from 'react'

// import { Container } from './styles';

function ListOsm({ mistreatmentId, osIds }) {
  if (!osIds || !osIds.length) return null

  const { data, loading, error } = useAxiosRequest(
    mistreatments.getOsmByMistreatment,
    mistreatmentId,
    osIds,
  )

  return (
    <Card.Base className="mt-2">
      <Card.Header>
        <Flexbox.Columns className="align-center">
          <Flexbox.Column>
            <div className="h5">Ordens de Serviço</div>
          </Flexbox.Column>
          <Flexbox.Column className="col-auto">
            <i className="fas fa-bullhorn" />
          </Flexbox.Column>
        </Flexbox.Columns>
      </Card.Header>
      <Card.Body>
        <LoadManager loading={loading} error={error}>
          {
            Boolean(data) && (
              data.map((osm) => (
                <div key={osm.id} className="mb-2 bg-gray s-rounded p-2">
                  <div>
                    <small>Assunto</small>
                    <div>
                      <b>{osm?.assunto?.descricao}</b>
                    </div>
                  </div>
                  <div className="mt-1">
                    Responsável: <b>{osm?.usuario_responsavel?.nome ?? '-'}</b>
                  </div>

                  <div className="mt-1">
                    Situação: <b className={statusColorMap[osm?.situacao]}>{singularStatusMapLabel[osm?.situacao] ?? osm?.situacao ?? '-'}</b>
                  </div>

                  <div className="mt-2">
                    <small>OS-m criada em: <b>{dateMask(osm?.created_at)}</b></small>
                  </div>

                  <div className="mt-2">
                    <small><a href={osm.url} target="_blank" rel="noopener noreferrer">{osm.url}</a></small>
                  </div>
                </div>
              ))
            )
          }
        </LoadManager>
      </Card.Body>
    </Card.Base>
  )
}

ListOsm.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  mistreatmentId: PropTypes.any.isRequired,
  osIds: PropTypes.arrayOf(Object),
}

ListOsm.defaultProps = {
  osIds: undefined,
}

export default ListOsm
